const selectors = {
  listSearchCampaignResult: (state) => state.campaign.listSearchCampaignResult,
  listTopKeywordResult: (state) => state.campaign.listTopKeywordResult,
  listDisplayCampaignResult: (state) => state.campaign.listDisplayCampaignResult,
  listTopAudienceResult: (state) => state.campaign.listTopAudienceResult,
  listTopPlacementResult: (state) => state.campaign.listTopPlacementResult,
};

export default selectors;
